import { render, staticRenderFns } from "./accountShareModule.vue?vue&type=template&id=34d3ffb9&scoped=true&"
import script from "./accountShareModule.vue?vue&type=script&lang=js&"
export * from "./accountShareModule.vue?vue&type=script&lang=js&"
import style0 from "./accountShareModule.vue?vue&type=style&index=0&id=34d3ffb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d3ffb9",
  null
  
)

export default component.exports